<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="83" height="73" viewBox="0 0 83 73" fill="none">
    <path
      d="M81.5 58.375L66.8645 43.9681C66.031 43.1479 64.9007 42.6872 63.7222 42.6872C62.5437 42.6872 61.4135 43.1479 60.58 43.9681L57.9756 46.5319C57.1421 47.3521 56.0118 47.8128 54.8333 47.8128C53.6548 47.8128 52.5246 47.3521 51.6911 46.5319L38.8956 33.9362C37.2286 32.2959 34.9681 31.3744 32.6111 31.3744C30.2541 31.3744 27.9936 32.2959 26.3267 33.9362L1.5 58.375M81.5 5.875V67.125C81.5 68.2853 81.0317 69.3981 80.1983 70.2186C79.3648 71.0391 78.2343 71.5 77.0556 71.5H5.94444C4.7657 71.5 3.63524 71.0391 2.80175 70.2186C1.96825 69.3981 1.5 68.2853 1.5 67.125V5.875C1.5 4.71468 1.96825 3.60188 2.80175 2.78141C3.63524 1.96094 4.7657 1.5 5.94444 1.5H77.0556C78.2343 1.5 79.3648 1.96094 80.1983 2.78141C81.0317 3.60188 81.5 4.71468 81.5 5.875ZM59.2778 19C59.2778 20.1603 58.8095 21.2731 57.976 22.0936C57.1425 22.9141 56.0121 23.375 54.8333 23.375C53.6546 23.375 52.5241 22.9141 51.6906 22.0936C50.8571 21.2731 50.3889 20.1603 50.3889 19C50.3889 17.8397 50.8571 16.7269 51.6906 15.9064C52.5241 15.0859 53.6546 14.625 54.8333 14.625C56.0121 14.625 57.1425 15.0859 57.976 15.9064C58.8095 16.7269 59.2778 17.8397 59.2778 19Z"
      stroke="url(#paint0_linear_83_6727)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_83_6727"
        x1="81.5"
        y1="41.9508"
        x2="2.49993"
        y2="50.8387"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
